var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.labelInsideTextarea
    ? _c("div", { staticClass: "custom-textarea" }, [
        _vm.label
          ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
          : _vm._e(),
        _vm._v(" "),
        _c("textarea", {
          attrs: { placeholder: _vm.placeholder, disabled: _vm.disabled },
          domProps: { value: _vm.value },
          on: { input: event => _vm.$emit("update", event.target.value) }
        })
      ])
    : _c(
        "div",
        [
          _c(
            "md-field",
            {
              class: [
                "input",
                { "md-invalid": _vm.errors.length || _vm.hasExceededMaxLength }
              ]
            },
            [
              _vm.label
                ? _c("label", [
                    _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "md-textarea",
                _vm._b(
                  {
                    attrs: {
                      value: _vm.value,
                      placeholder: _vm.placeholder,
                      disabled: _vm.disabled
                    },
                    on: { input: _vm.onChange }
                  },
                  "md-textarea",
                  _vm.inputProps,
                  false
                )
              ),
              _vm._v(" "),
              _vm.errors.length
                ? _vm._l(_vm.errors, function(error, index) {
                    return _c("span", { key: index, staticClass: "md-error" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t(`errors.${error}`)) +
                          "\n      "
                      )
                    ])
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.maxLength
            ? _c(
                "div",
                {
                  staticClass: "counter flex justify-end",
                  class: { "counter--error": _vm.hasExceededMaxLength }
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.value.length) +
                      " / " +
                      _vm._s(_vm.maxLength) +
                      "\n  "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }